import React from "react";
import {
    Button,
    convertInputFormToObject,
    InputForm,
    inputStyles,
    TextField,
    useInputForm
} from "../../../../Components/Inputs";
import {clearInputFormFields} from "../../../../Components/Inputs/inputUtility";
import {gridConstants, GridContainer, GridCell} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";
import {isFimcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {loanHistorySearchModel} from "./loanHistorySearchFactory";

import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface LoanHistorySearchFormViewProps {
    dropDowns: Record<string, any>;
    handleSetLoanHistorySearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
    loanHistorySearchCriteria: Record<string, any>;
    students?: ListItem[];
}

export const LoanHistorySearchFormView = ({
                                              dropDowns,
                                              handleSetLoanHistorySearchCriteria,
                                              isLoading,
                                              loanHistorySearchCriteria,
                                              students = []
                                          }: LoanHistorySearchFormViewProps) => {

    const patrons = createListFromArrayOfObjects(dropDowns?.patrons, "userId", "fullName");
    const shippingLocations = createListFromArrayOfObjects(dropDowns?.shippingLocations, "shippingLocationId", "name");
    const districts = createListFromArrayOfObjects(dropDowns?.districts, "districtId", "districtName");
    const organizations = createListFromArray(dropDowns?.organizations);

    const searchForm = useInputForm(loanHistorySearchModel());

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedLoanHistorySearchCriteria = {...loanHistorySearchCriteria};
        updatedLoanHistorySearchCriteria.ClearLoanHistorySearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedLoanHistorySearchCriteria = {...loanHistorySearchCriteria};
        updatedLoanHistorySearchCriteria.Search(criteria);
        handleSetLoanHistorySearchCriteria(updatedLoanHistorySearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.THREE,
    };

    return <>
        <InputForm name={"loanHistorySearch"} hasPaddingY>
            {
                isFimcAdmin() &&
                <SearchableSingleSelectField
                    {...searchForm.patronId}
                    {...inputSharedSettings}
                    includeDefaultOption
                    label={'Patron'}
                    options={patrons}
                />
            }

            <TextField
                {...searchForm.itemName}
                {...inputSharedSettings}
            />

            <SearchableSingleSelectField
                {...searchForm.shippingLocationId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Shipping Locations'}
                options={shippingLocations}
            />

            <SearchableSingleSelectField
                {...searchForm.studentId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Student'}
                options={students}
            />

            {
                isFimcAdmin() &&
                <>
                    <SearchableSingleSelectField
                        {...searchForm.districtId}
                        {...inputSharedSettings}
                        includeDefaultOption
                        label={'District'}
                        options={districts}
                    />

                    <SearchableSingleSelectField
                        {...searchForm.organization}
                        {...inputSharedSettings}
                        includeDefaultOption
                        options={organizations}
                    />
                </>
            }


            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            label="Search"
                            name="btnSearchLoan"
                            onClick={handleSearchClick}
                            isPrimary
                        />
                    </GridCell>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            name="btnClearLoanSearch"
                            onClick={handleClearClick}
                            label="Clear"
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>
};
